import { getTimelineSummary } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineSummaryGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreTimelineSummary',
	receive: true,
	request: true,
	requestHandler: getTimelineSummary,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
